import { Button } from '@cian/ui-kit';
import { IconProductPanorama36016 } from '@cian/ui-kit-design-tokens/icons';
import styles from './PanoramaPreview.css';
import { FC } from 'react';

interface IPanoramaPreviewProps {
  onClick: VoidFunction;
}

export const PanoramaPreview: FC<IPanoramaPreviewProps> = ({ onClick }) => {
  return (
    <div className={styles['preview']} onClick={onClick}>
      <div className={styles['inner']}>
        <Button theme="fill_white_primary" beforeIcon={<IconProductPanorama36016 color="icon-main-default" />} size="M">
          Смотреть панораму
        </Button>
      </div>
    </div>
  );
};
